import P5 from "p5";
import p5 from "p5";
import "./styles.scss";
import ISketchformer from "./ISketchformer";
import Sketchformer from "./Sketchformer";
import $ from "jquery";
import Mesh from "./Mesh"
import CameraWrapper from "./CameraWrapper";
import {Models} from "./Models";

const sketch = (p5: P5) => {
	let sketchformer: ISketchformer;
	let renderCross: boolean = false;
	let renderInformation: boolean = true;
	let crossSize: number = 0;
	let camera1: P5.Camera;

	let sliderGroup:any[] = [];
	let X;
	let Y;
	let Z;
	let centerX;
	let centerY;
	let centerZ;
	let h = 20;
	let mousepos: P5.Vector;

	function zoom(event: any): void {
		if (event.deltaY > 0) {
			sketchformer.cameraWrapper.zoomIn();
		} else {
			sketchformer.cameraWrapper.zoomOut();
		}
	}

	function toggleRenderCross(): void {
		renderCross = !renderCross;
	}

	function toggleTriangleCenter(): void {
		renderCross = !renderCross;
	}

	function toggleInformation(): void {
		
		renderInformation = !renderInformation;
		if (!renderInformation) {
			$("#hud").css("visibility", "hidden");
		}
		else {
			$("#hud").css("visibility", "visible");
		}
	}

	function setupInterfaces(mySize: number): void {
		const x: number = p5.windowWidth/2 + mySize/2;
		let y: number = 70;

		y+=50;

		// Rendering
		$("#toggle-information").on('click', toggleInformation);		
		$("#toggle-wireframe").on('click', () => sketchformer.toggleWireframe());
		$("#toggle-fill").on('click', () => sketchformer.toggleFill());
		$("#toggle-cross").on('click', toggleRenderCross);
		$("#toggle-triangle-center").on('click', () => sketchformer.toggleTriangleCenter());
		$("#refine-button").on('click', () => sketchformer.refine());
		
		$.each(Models, (key, value: string) => {
			if (value == "bunny") {
				$("#model-select").append(`<option value="${value}" selected>${value}</option>`);
			}
			else {
				$("#model-select").append(`<option value="${value}">${value}</option>`);
			}
		  });
		$("#model-select").on('change', (event) => sketchformer.loadModel($("#model-select option:selected").val() as string));
	}

	function updateHud(fps: number, nv: number, nf: number): void {
		$("#hud-fps").html(`fps: ${fps.toFixed(0)}`);
		$("#hud-nv").html(`number of vertices: ${nv}`);// mouse ${p5.mouseX} ${p5.mouseY}`);
		$("#hud-nf").html(`number of faces: ${nf}`);// gc ${sketchformer.mesh.geometricCenter} camera ${sketchformer.cameraWrapper.position}`);
	}

	function updateHud2(info: string): void {
		$("#hud-info").html(info);
	}

	p5.setup = () => {
		const gap = 200;
		const mySize = Math.min(p5.windowWidth, p5.windowHeight)-gap;
		const canvas = p5.createCanvas(p5.windowWidth-gap, p5.windowHeight-60, p5.WEBGL);
		canvas.parent("sketch");
		canvas.mouseWheel(zoom);
		const camera = new CameraWrapper(0, 0, -1000, 10, p5);
		const mesh = new Mesh(p5);
		sketchformer = new Sketchformer(p5.windowWidth, p5.windowHeight-60, mesh, camera);
		sketchformer.loadModel("bunny");
		crossSize = Math.max(p5.windowWidth, p5.windowHeight)*1000;
		var p1 = sketchformer.mesh.geometricCenter.copy();
		p1.z = -1000;
		p1.z = 500
		camera.setPositionTo(new P5.Vector(0,0,1000));
		sketchformer.cameraWrapper.cam.ortho();
		//camera.setHudCamera(p1.x, p1.y);
		setupInterfaces(mySize);

		let titles: string[] = ["near", "far", "top", "bottom", "left", "right"];
		//create sliders
		for (var i = 0; i < 6; i++) {
			if (i === 2) {
				sliderGroup[i] = p5.createSlider(-1000, 1000, 200);
			} else {
				sliderGroup[i] = p5.createSlider(-1000, 1000, 0);
			}
			h = p5.map(i, 0, 6, 5, 125);
			let title1 = p5.createElement("span", titles[i]);
			title1.position(p5.width, p5.height - h);
			sliderGroup[i].position(p5.width+80, p5.height - h);
			sliderGroup[i].style('width', '80px');
		}
	};

	p5.draw = () => {
		if (renderInformation) {
			updateHud(p5.frameRate(), sketchformer.mesh.numberOfVertices, sketchformer.mesh.numberOfTriangles);
		}

		p5.frameRate(60);
		p5.background(0);
		p5.orbitControl();
		if (!sketchformer.mesh.loaded) {
			p5.push();
				p5.rotateY(p5.millis() / 1000);
				p5.fill('green');
				p5.stroke('red');
				p5.box(p5.width/5, p5.width/5);
			p5.pop();

			// don't need further rendering
			return;
		}
		//p5.setCamera(sketchformer.cameraWrapper.cam)
        p5.push();
	/*
            var coord1 = p5.createVector(p5.mouseX, p5.mouseY, 0);
			var rv = sketchformer.cameraWrapper.rightVectorUndo;
			var uv = sketchformer.cameraWrapper.upVectorUndo;
			var vd = sketchformer.cameraWrapper.viewDirUndo;
			var cp = p5.createVector(0,0,-1000)

			var crv = sketchformer.cameraWrapper.rightVector;
			var cuv = sketchformer.cameraWrapper.upVector;
			var cvd = sketchformer.cameraWrapper.viewDir;
			var ccp = sketchformer.cameraWrapper.position;

			var gc = sketchformer.mesh.geometricCenter;
			var p1 = sketchformer.mesh.geometricCenter.copy();
			p1.z = -1000;
            //p5.translate(-gc.x, gc.y,0);

			//p5.translate(0, 0, -sketchformer.cameraWrapper.position.z);
			var coord3 = p5.createVector(
				gc.dot(rv),
				gc.dot(uv),
				gc.dot(vd));
			
			var coord4 = p5.createVector(
				cp.dot(rv),
				cp.dot(uv),
				cp.dot(vd));

			var coord5 = p5.createVector(
				cp.dot(crv),
				cp.dot(cuv),
				cp.dot(cvd));

			
			var mouseInOriginialCamera = p5.createVector(
				coord1.dot(rv),
				coord1.dot(uv),
				coord1.dot(vd));

			var mouseInRotatedCamera = p5.createVector(
				coord1.dot(crv),
				coord1.dot(cuv),
				coord1.dot(cvd));

			var diffBetweenMouse = p5.createVector(
				mouseInOriginialCamera.x-mouseInRotatedCamera.x,
				mouseInOriginialCamera.y-mouseInRotatedCamera.y,
				mouseInOriginialCamera.z-mouseInRotatedCamera.z,
			);

			var rvDotCcp = rv.copy();
			rvDotCcp.dot(ccp);
			var uvDotCcp = uv.copy();
			uvDotCcp.dot(ccp);
			var vdDotCcp = vd.copy();
			vdDotCcp.dot(ccp);
			
			// knowing that camera has been translated/rotated by coord4
			// undo it
			var coordBy = diffBetweenMouse.copy();
			coordBy.mult(-1);

			// go back by the recorded vector
			//coord1.sub(crv);
			//coord1.sub(cuv);
			//coord1.sub(cvd);
			//sketchformer.cameraWrapper.cam.
			mousepos = p5.createVector(-p5.width/2+p5.mouseX, -p5.height/2+p5.mouseY, 0);
			const previousComponents:P5.Vector = new P5.Vector(
				mousepos.dot(rv),
				mousepos.dot(uv),
				mousepos.dot(vd));
	
			// go back by the recorded vector
			var tempRightVector: P5.Vector = crv.copy();
			tempRightVector.mult(previousComponents.x);
			
			var tempUpVector: P5.Vector = cuv.copy();
			tempUpVector.mult(previousComponents.y);
			
			var tempViewDir: P5.Vector = cvd.copy();
			tempViewDir.mult(previousComponents.z);
			let coord123 = p5.createVector(
				tempRightVector.x +
				tempUpVector.x +
				tempViewDir.x,
				tempRightVector.y +
				tempUpVector.y +
				tempViewDir.y,
				tempRightVector.z +
				tempUpVector.z +
				tempViewDir.z);
			//updateHud2(`mousepos: ${mousepos} coord123 ${coord123} previousComponents ${previousComponents} tempRightVector ${tempRightVector}` )
				//p5.translate(-p5.width/2, -p5.height/2, 0);
				//p5.translate(coordBy.x, coordBy.y,coordBy.z);
				p5.translate(coord123.x, coord123.y, coord123.z);
				//p5.translate(coord1.x, coord1.y, 0);
				p5.fill(0,0,255);
				p5.sphere(10, 10, 10);
	    p5.pop();*/

		p5.push();/*
			X = sliderGroup[0].value();
			Y = sliderGroup[1].value();
			Z = sliderGroup[2].value();
			centerX = sliderGroup[3].value();
			centerY = sliderGroup[4].value();
			centerZ = sliderGroup[5].value();
			p5.camera(X, Y, Z, centerX, centerY, centerZ, 0, 1, 0);*/
			p5.smooth();
			sketchformer.render();
		p5.pop();

		// assume draw mode, turn off camera
		//sketchformer.cameraWrapper.render();

		if (renderCross) {
			p5.push();
				p5.strokeWeight(4);
			 	p5.noFill();
			 	p5.stroke('red');
			 	p5.line(-crossSize, 0, 0, crossSize, 0, 0);
			 	p5.line(0, -crossSize, 0, 0, crossSize, 0);
			 	p5.line(0, 0, -crossSize, 0, 0, crossSize);
			p5.pop();
		}
		//sketchformer.computeIntersection();
	};

	p5.mouseDragged = () => {
		sketchformer.cameraWrapper.rotateAroundOrigin(p5.winMouseY-p5.pwinMouseY,p5.winMouseX-p5.pwinMouseX);
	}

	p5.mouseMoved = () => {
		//console.log(`mousemoved ${p5.mouseX}, ${p5.mouseY}`);
		//sketchformer.computeIntersection();

	}

	p5.keyPressed = () => {
		if (p5.keyCode === 84) {
			sketchformer.computeIntersection2(p5.mouseX, p5.mouseY);
			//console.log("shoot a ray, compute intersection");
		}
	}
};


new P5(sketch);
